<template>
  <div v-if="isPageContactList">
    <transition name="slide-fade" v-if="selectedContacts.length || isMobile">
      <div
        class="tw-fixed tw-bottom-0 tw-grid tw-place-items-center tw-z-[1] tw-isolate tw-w-[100%] tw-h-[106px] tw-rounded-t-[20px] md:tw-rounded-none tw-bg-[var(--my-primary)] tw-shadow-[0px_2px_20px_rgba(0,0,0,0.25)] md:tw-shadow-none tw-font-lato tw-leading-[var(--my-leading)]"
      >
        <transition mode="out-in">
          <div class="fade-block" key="1" v-if="!selectedContacts.length && isMobile">
            <stat-bar />
          </div>

          <div class="fade-block" v-else key="2">
            <select-bar />
          </div>
        </transition>
      </div>
    </transition>
    <div
      v-if="selectedContacts.length || isMobile"
      class="tw-h-[106px] tw-bg-[var(--my-text-color)]"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import selectBar from "@/views/donor-dashboard/my-contacts/contact-list/fixed-select-bar/select-bar.vue";
import statBar from "@/views/donor-dashboard/my-contacts/contact-list/fixed-select-bar/stat-bar.vue";

export default {
  components: {
    selectBar,
    statBar,
  },

  data() {
    return {
      isMobile: false,
    };
  },

  computed: {
    ...mapState({
      selectedContacts: (state) => state.donorMyContacts.selectedContacts,
    }),

    isPageContactList() {
      return this.$route.name === "donor-my-contact-list";
    },
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },

  name: "fixed-select-bar",
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(53px);
}

.fade-block {
  transition: opacity 0.3s ease;
  &.v-enter-active,
  &.v-leave-active {
    transition: opacity 0.3s ease;
  }
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }
}
</style>
